import { render } from "./component-egrul-organ.vue?vue&type=template&id=2b4b73c7"
import script from "./component-egrul-organ.vue?vue&type=script&setup=true&lang=js"
export * from "./component-egrul-organ.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/counteragents/counteragent-version-card/components/component-egrul-organ.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2b4b73c7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2b4b73c7', __exports__)) {
    api.reload('2b4b73c7', __exports__)
  }
  
  module.hot.accept("./component-egrul-organ.vue?vue&type=template&id=2b4b73c7", () => {
    api.rerender('2b4b73c7', render)
  })

}


export default __exports__